import React from "react";
import "./cardFlip.css";
import Card from "../../models/Card";
import { Trans } from "react-i18next";
import toast from "react-hot-toast";
import DatabaseService from "../../utils/storage/databaseService";

interface Props { card: Card; t: (k: string) => string; onUpdate?: () => void; }
interface State { flipped: boolean; }

class CardFlip extends React.Component<Props, State> {
  constructor(p: Props) { super(p); this.state = { flipped: false }; }
  handleMaster = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const c = this.props.card;
    c.mastered = !c.mastered;
    c.reviewedAt = c.mastered ? Date.now() : 0;
    c.reviewCount++;
    await DatabaseService.updateRecord(c, "cards");
    toast.success(c.mastered ? this.props.t("Marked as mastered") : this.props.t("Moved back to review"));
    this.props.onUpdate?.();
  };
  handleDelete = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!window.confirm(this.props.t("Delete this card?"))) return;
    await DatabaseService.deleteRecord(this.props.card.key, "cards");
    toast.success(this.props.t("Deletion successful"));
    this.props.onUpdate?.();
  };

  render() {
    const { card } = this.props;
    const d = `${card.date.year}-${String(card.date.month).padStart(2,"0")}-${String(card.date.day).padStart(2,"0")}`;
    return (
      <div className="cfc" onClick={() => this.setState((p) => ({ flipped: !p.flipped }))}>
        <div className={`cfi ${this.state.flipped ? "flipped" : ""}`}>
          <div className="cff">
            <div className="cfl"><Trans>English</Trans>{card.mastered && <span className="cmb"><Trans>Mastered</Trans></span>}</div>
            <div className="cfx">{card.originalText}</div>
            <div className="cfm"><span>{card.chapter}</span><span>{d}</span></div>
            {card.tags.length > 0 && <div className="cft">{card.tags.map((t: string) => <span key={t} className="ctg">{t}</span>)}</div>}
          </div>
          <div className="cfb">
            <div className="cfl"><Trans>Chinese</Trans></div>
            <div className="cfx">{card.translatedText || <span style={{opacity:.5}}><Trans>No translation</Trans></span>}</div>
            <div className="cfa"><button className="cab master" onClick={this.handleMaster}>{card.mastered ? <Trans>Undo Mastered</Trans> : <Trans>Mark as Mastered</Trans>}</button><button className="cab delete" onClick={this.handleDelete}><Trans>Delete</Trans></button></div>
          </div>
        </div>
      </div>
    );
  }
}
export default CardFlip;
